import { useState } from 'react'
import { CButton, CCollapse, CContainer } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'
import { useQuery } from '@tanstack/react-query'
import { NavLink, Outlet } from 'react-router-dom'
import { publicApi } from '../api/client'
import { useAuth } from '../auth/AuthProvider'
import { BrandLogo } from '../components/common/BrandLogo'
import { StatusPill } from '../components/common/StatusPill'

const publicLinks = [
  { to: '/observatory', label: 'H100 Live' },
  { to: '/ledger', label: 'Compute Ledger' },
  { to: '/services', label: 'Services' },
  { to: '/research', label: 'Research Outputs' },
  { to: '/stewardship', label: 'Stewardship' },
]

export function PublicLayout() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const { user } = useAuth()
  const overview = useQuery({
    queryKey: ['public', 'overview', '24h', 'header'],
    queryFn: () => publicApi.overview('24h'),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })

  return (
    <div className="public-shell">
      <header className="public-header">
        <CContainer xxl>
          <div className="public-header__row">
            <BrandLogo />
            <nav className="public-nav public-nav--desktop" aria-label="Public navigation">
              {publicLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
            <div className="public-header__actions">
              {overview.data && (
                <StatusPill
                  state={overview.data.machine.state}
                  small
                  pulse={overview.data.machine.telemetryFresh}
                />
              )}
              <CButton color={user ? 'primary' : 'light'} href={user ? '/console' : '/login'}>
                {user ? 'Open console' : 'Member sign in'}
              </CButton>
              <CButton
                className="public-header__menu"
                color="light"
                aria-label="Toggle navigation"
                aria-expanded={mobileOpen}
                onClick={() => setMobileOpen((value) => !value)}
              >
                <CIcon icon={cilMenu} />
              </CButton>
            </div>
          </div>
          <CCollapse visible={mobileOpen}>
            <nav className="public-nav public-nav--mobile" aria-label="Mobile navigation">
              {publicLinks.map((link) => (
                <NavLink key={link.to} to={link.to} onClick={() => setMobileOpen(false)}>
                  {link.label}
                </NavLink>
              ))}
            </nav>
          </CCollapse>
        </CContainer>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="public-footer">
        <CContainer xxl>
          <div className="public-footer__grid">
            <div>
              <BrandLogo compact />
              <p>Responsible AI infrastructure, visible from computation to publication.</p>
            </div>
            <div>
              <strong>Public record</strong>
              <NavLink to="/ledger">Compute Ledger</NavLink>
              <NavLink to="/stewardship">Definitions & governance</NavLink>
            </div>
            <div>
              <strong>LARICE Lab</strong>
              <span>Electrical and Computer Engineering</span>
              <span>Thammasat School of Engineering</span>
            </div>
          </div>
          <div className="public-footer__bottom">
            <span>© {new Date().getFullYear()} LARICE Lab</span>
            <span>Times shown in Asia/Bangkok (ICT)</span>
          </div>
        </CContainer>
      </footer>
    </div>
  )
}
